import { render } from "./ProgramsPage.vue?vue&type=template&id=044880ba"
import script from "./ProgramsPage.vue?vue&type=script&lang=js"
export * from "./ProgramsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__